import styled from 'styled-components';

export const Container = styled.div`
  h1 {
    text-transform: uppercase;
    font-size: 1.2rem;
    margin-bottom: 20px;
    color: #525252;
  }
  a, .btn-link {
    color: #9a9a9a;
  }
  .recoverPassword {
    margin-bottom: 0;
    margin-top: 10px;
    text-align: right;
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/Login/styles.js